<ion-app>
  <app-airbnb-toast />
  <p-confirmdialog />
  <ion-router-outlet></ion-router-outlet>
</ion-app>